var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "tw-report flex items-center justify-between gap-3 mb-3 flex-wrap text-slate-700",
        },
        [
          _c("h3", { staticClass: "text-sm font-semibold text-foreground" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "inline-flex items-center gap-2 text-[11px]" },
            [
              _vm.user_id
                ? _c(
                    "button",
                    {
                      staticClass: "iframe-action-btn",
                      attrs: { id: "aiPreviewBtn", title: "AI Edit" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "M20 3v4" } }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "M22 5h-4" } }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("AI Edit")]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-xs font-semibold transition-colors",
                  class: _vm.localShowMobileLegibility
                    ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                    : "border-slate-200 bg-white text-slate-500 hover:text-slate-900",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.localShowMobileLegibility =
                        !_vm.localShowMobileLegibility
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-phone text-xs" }),
                  _vm._v("\n        Mobile legibility\n      "),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted-foreground font-medium" }, [
                _vm._v("Order:"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "inline-flex items-center rounded-full border border-slate-300 bg-slate-100 p-1 font-medium shadow-sm",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "appearance-none border-0 px-3 py-1.5 rounded-full text-sm font-semibold leading-none transition-colors focus:outline-none focus:ring-0",
                      class: !_vm.localShowRecommendedOrder
                        ? "bg-white text-slate-900 shadow-sm"
                        : "bg-transparent text-slate-500 hover:text-slate-900",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.localShowRecommendedOrder = false
                        },
                      },
                    },
                    [_vm._v("\n          Current\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "appearance-none border-0 px-3 py-1.5 rounded-full text-sm font-semibold leading-none transition-colors focus:outline-none focus:ring-0",
                      class: _vm.localShowRecommendedOrder
                        ? "bg-white text-slate-900 shadow-sm"
                        : "bg-transparent text-slate-500 hover:text-slate-900",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.localShowRecommendedOrder = true
                        },
                      },
                    },
                    [_vm._v("\n          Recommended\n        ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "relative" }, [
        _c("div", { staticClass: "overflow-x-auto pb-3 mx-3" }, [
          _c(
            "div",
            {
              staticClass:
                "grid grid-flow-col auto-cols-[170px] gap-3 text-slate-700",
            },
            _vm._l(_vm.displayImageOrder, function (slot, index) {
              return _c(
                "div",
                {
                  key: _vm.makeSlotKey(slot, index),
                  staticClass: "group relative",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full aspect-square rounded-lg overflow-hidden flex items-center justify-center relative transition-all text-left",
                      class: _vm.getDisplaySlotButtonClass(slot, index),
                      attrs: {
                        role: "button",
                        "aria-disabled": !_vm.isDisplaySlotClickable(
                          slot,
                          index
                        ),
                        tabindex: _vm.isDisplaySlotClickable(slot, index)
                          ? 0
                          : -1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleDisplaySlotClick(slot, index)
                        },
                        keydown: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.handleDisplaySlotClick(slot, index)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            )
                              return null
                            $event.preventDefault()
                            return _vm.handleDisplaySlotClick(slot, index)
                          },
                        ],
                      },
                    },
                    [
                      slot.ai_src
                        ? [
                            _c("img", {
                              staticClass: "w-full h-full object-contain",
                              attrs: { src: slot.ai_src, alt: slot.type },
                            }),
                          ]
                        : slot.src &&
                          (slot.status === "present" ||
                            slot.status === "improve")
                        ? [
                            _c("img", {
                              staticClass: "w-full h-full object-contain",
                              attrs: { src: slot.src, alt: slot.type },
                            }),
                          ]
                        : _vm.isDisplaySlotLocked(slot, index)
                        ? [_vm._m(1, true)]
                        : slot.status === "missing" || slot.status === "improve"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col items-center gap-1 px-2 text-center",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "bi bi-stars text-primary text-base",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-[10px] font-semibold text-primary leading-tight",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          slot.status === "improve"
                                            ? "Preview upgrade"
                                            : "Preview with AI"
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDisplaySlotGenerating(slot, index)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute inset-0 z-20 flex flex-col items-center justify-center gap-2 px-3 text-center bg-white/80 backdrop-blur-[2px]",
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "bi bi-arrow-repeat text-primary text-lg animate-spin",
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-[10px] font-semibold text-primary leading-tight",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.currentGenerationStage.label) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-[82%] h-1.5 rounded-full bg-primary/15 overflow-hidden",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "h-full bg-primary transition-all duration-200 ease-out",
                                    style: {
                                      width:
                                        Math.round(
                                          _vm.generationProgress * 100
                                        ) + "%",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-[9px] text-muted-foreground leading-tight",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        Math.round(_vm.generationProgress * 100)
                                      ) +
                                      "%\n              "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "absolute z-30 top-1.5 left-1.5 inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold bg-background/90 border border-border",
                          class:
                            slot.status === "present" ||
                            slot.status === "improve"
                              ? "text-foreground"
                              : "text-muted-foreground",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(index + 1) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      slot.status === "present" && !slot.ai_src
                        ? _c("i", {
                            staticClass:
                              "bi bi-check-circle-fill absolute z-30 top-1.5 right-1.5 text-emerald-500 bg-background rounded-full text-sm",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      slot.status === "improve" &&
                      !slot.ai_src &&
                      _vm.generatingSlot !==
                        _vm.getGenerationSlotIndex(slot, index)
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "absolute z-40 top-1.5 right-1.5 inline-flex items-center gap-0.5 h-5 px-1.5 rounded text-[9px] text-white border-0 transition-colors",
                              class: _vm.isDisplayImproveButtonDisabled(
                                slot,
                                index
                              )
                                ? "bg-amber-300 cursor-not-allowed opacity-80"
                                : "bg-amber-500 hover:bg-amber-600 cursor-pointer",
                              attrs: {
                                type: "button",
                                disabled: _vm.isDisplayImproveButtonDisabled(
                                  slot,
                                  index
                                ),
                                title: _vm.getDisplayImproveTitle(slot, index),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.handleImproveClick(slot, index)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-arrow-up-right text-[9px]",
                              }),
                              _vm._v("\n              Improve\n            "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      slot.ai_src
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "absolute z-30 top-1.5 right-1.5 inline-flex items-center gap-0.5 h-5 px-1.5 rounded text-[9px] bg-primary text-primary-foreground border-0 text-white",
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-stars text-[9px]",
                              }),
                              _vm._v("\n              AI\n            "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.shouldShowMobileLegibilityBadge(slot)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mobile-legibility-badge absolute z-41 right-1.5 bottom-1.5",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "mobile-legibility-badge__btn",
                                  class:
                                    _vm.getMobileLegibilityBadgeClass(slot),
                                  attrs: {
                                    type: "button",
                                    "aria-label":
                                      _vm.getMobileLegibilityLabel(slot),
                                  },
                                },
                                [
                                  _vm.getMobileLegibilityStatus(slot) ===
                                  "ready"
                                    ? _c(
                                        "svg",
                                        {
                                          staticClass: "h-5 w-5",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "3",
                                              width: "10",
                                              height: "18",
                                              rx: "2.4",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M10 6.5H14",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("circle", {
                                            attrs: {
                                              cx: "12",
                                              cy: "17.6",
                                              r: "0.9",
                                              fill: "currentColor",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M5.4 12.1L9.6 16.3L18.9 7",
                                              stroke: "currentColor",
                                              "stroke-width": "2.6",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "svg",
                                        {
                                          staticClass: "h-5 w-5",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "3",
                                              width: "10",
                                              height: "18",
                                              rx: "2.4",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M10 6.5H14",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("circle", {
                                            attrs: {
                                              cx: "12",
                                              cy: "17.6",
                                              r: "0.9",
                                              fill: "currentColor",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M5 5L19 19",
                                              stroke: "currentColor",
                                              "stroke-width": "2.8",
                                              "stroke-linecap": "round",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M19 5L5 19",
                                              stroke: "currentColor",
                                              "stroke-width": "2.7",
                                              "stroke-linecap": "round",
                                            },
                                          }),
                                        ]
                                      ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mobile-legibility-tooltip" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mobile-legibility-tooltip__title",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getMobileLegibilityLabel(slot)
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.getMobileLegibilityReason(slot)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mobile-legibility-tooltip__text",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.getMobileLegibilityReason(
                                                  slot
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getDisplaySlotDownloadUrl(slot, index)
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "absolute z-40 right-1.5 inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/90 border border-slate-200 text-slate-700 shadow-sm opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 hover:bg-white hover:text-slate-950 transition-all",
                              class: _vm.shouldShowMobileLegibilityBadge(slot)
                                ? "bottom-9"
                                : "bottom-1.5",
                              attrs: { href: "#", title: "Download image" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.downloadDisplaySlotImage(
                                    slot,
                                    index
                                  )
                                },
                              },
                            },
                            [_c("i", { staticClass: "bi bi-download text-xs" })]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _vm.localShowRecommendedOrder
                        ? [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-[11px] font-semibold text-foreground leading-tight p-0 m-0",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(slot.type) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-[10px] text-muted-foreground leading-snug mt-0.5 p-0 m-0",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(slot.intent) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            slot.why_it_matters
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-[9px] text-muted-foreground/80 leading-snug mt-1 italic p-0 m-0",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(slot.why_it_matters) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : [
                            slot.status === "improve" && slot.improve_reason
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-[10px] text-amber-700 leading-snug p-0 m-0 mt-0.5",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(slot.improve_reason) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            slot.recommended_slot &&
                            slot.recommended_slot !== index + 1
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-[9px] text-blue-700 leading-snug p-0 m-0 mt-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                Recommended position: #" +
                                        _vm._s(slot.recommended_slot) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "pointer-events-none absolute right-0 top-0 h-full w-10 bg-gradient-to-l from-white to-transparent",
        }),
      ]),
      _vm._v(" "),
      _vm.showPreviewCta
        ? _c(
            "div",
            {
              staticClass:
                "mt-4 flex items-center justify-between gap-3 rounded-lg border border-dashed border-border bg-muted/30 px-4 py-2 flex-wrap",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center gap-2 text-xs text-muted-foreground",
                },
                [
                  _c("i", { staticClass: "bi bi-lock text-sm shrink-0" }),
                  _vm._v(" "),
                  _c("span", [
                    _c(
                      "span",
                      { staticClass: "font-semibold text-foreground" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.freePreviewUsed
                                ? "AI preview used"
                                : "1 free AI preview"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.freePreviewUsed
                            ? _vm.usedPreviewText
                            : _vm.unusedPreviewText
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "inline-flex items-center justify-center gap-1.5 h-7 px-3 rounded-md border border-border bg-background text-xs font-medium hover:bg-muted shrink-0",
                  attrs: { href: _vm.contactHref, target: "_blank" },
                },
                [
                  _c("i", { staticClass: "bi bi-stars text-xs" }),
                  _vm._v("\n      " + _vm._s(_vm.contactLabel) + "\n    "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "optix-lightbox-fade" } }, [
        _vm.lightboxImage
          ? _c(
              "div",
              {
                staticClass: "optix-lightbox",
                attrs: { role: "dialog", "aria-modal": "true" },
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    return _vm.closeLightbox.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "optix-lightbox__close",
                    attrs: {
                      type: "button",
                      "aria-label": "Close image preview",
                    },
                    on: { click: _vm.closeLightbox },
                  },
                  [_c("i", { staticClass: "bi bi-x-lg" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "optix-lightbox__content" }, [
                  _c("div", { staticClass: "optix-lightbox__image-wrap" }, [
                    _c("img", {
                      staticClass: "optix-lightbox__image",
                      attrs: {
                        src: _vm.lightboxImage,
                        alt: _vm.lightboxTitle || "Image preview",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.lightboxTitle || _vm.lightboxSubtitle
                    ? _c("div", { staticClass: "optix-lightbox__caption" }, [
                        _vm.lightboxTitle
                          ? _c(
                              "div",
                              { staticClass: "optix-lightbox__title" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.lightboxTitle) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.lightboxSubtitle
                          ? _c(
                              "div",
                              { staticClass: "optix-lightbox__subtitle" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.lightboxSubtitle) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "mb-8 flex items-start gap-3 rounded-xl border border-primary/20 bg-primary/5 px-3 py-3",
      },
      [
        _c("i", {
          staticClass: "bi bi-stars text-primary text-base shrink-0 mt-0.5",
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "text-sm text-foreground/80 leading-relaxed p-0 mt-0.5",
          },
          [
            _c("span", { staticClass: "font-semibold text-foreground" }, [
              _vm._v(
                "\n        93% of shoppers say visuals help decide the purchase\n      "
              ),
            ]),
            _vm._v("\n      — closing the gaps below lifts conversion.\n    "),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex flex-col items-center gap-1 px-2 text-center" },
      [
        _c("i", { staticClass: "bi bi-lock text-primary/60 text-sm" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "text-[10px] font-semibold text-foreground leading-tight",
          },
          [_vm._v("\n                  Recommended\n                ")]
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "text-[9px] text-muted-foreground leading-tight" },
          [_vm._v("\n                  Unlock preview\n                ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }